import { api } from '@api/api2';

export const getInvoiceStatus = () => api.v1('get', 'tck/payment-types/list');
